import { logTrace } from '@/shared/config/globalFunctions';
import { externalApi, wpApi } from '../../../shared/config/axiosConfig';
import store from '../../store';
import {
  ALLOWED_EXTENSIONS,
  CHANGE_LANGUAGE,
  C_INPUT_LIST,
  FETCH_FILE_REQUEST,
  FETCH_FILE_RESULT,
  FILE_LIST,
  FILE_TYPES,
  FILE_URL,
  GIM_PROJECTS,
  GLB_LOAD_STATE,
  INDUSTRY_DATA,
  INIT_PROJECT_LIST,
  INVOICE_LIST,
  LOG_OUT,
  PROJECT_LIST,
  SET_CUSTOMIZE_DATA,
  SET_DOWNLOAD_PROGRESS,
  SET_GIM_CONNECTION,
  SET_HIDE_INSTALL_BUTTON,
  SET_IFRAME_STATE,
  SET_MOBILE_VIEW,
  SET_UPLOAD_PROGRESS,
  SET_ZOOM_IN_LIMIT,
  USER_INFO,
} from '../../types/user';
import * as qs from 'qs';
import { assertProjectApiSuccess } from './projectApiGuards.js';
import { publishAuthEvent } from '../../../services/webAPI/authChannel';
import { logoutBrowserSession } from '../../../services/webAPI/auth.service';
/** @see assertProjectApiSuccess */
export { assertProjectApiSuccess } from './projectApiGuards.js';
//@ts-ignore
const storeInstance = store();

/**
 *
 * @returns
 */
export const setZoomInLimit = (data) => async (dispatch) => {
  dispatch({
    type: SET_ZOOM_IN_LIMIT,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setGlbLoadState = (data) => async (dispatch) => {
  dispatch({
    type: GLB_LOAD_STATE,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setCustomizeData = (data) => async (dispatch) => {
  dispatch({
    type: SET_CUSTOMIZE_DATA,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setIframeState = (data) => async (dispatch) => {
  dispatch({
    type: SET_IFRAME_STATE,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setHideInstallButton = (data) => async (dispatch) => {
  if (data) logTrace('HIDING INSTALL BUTTON');
  else logTrace('SHOWIND INSTALL BUTTON');
  dispatch({
    type: SET_HIDE_INSTALL_BUTTON,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setDownloadProgress = (data) => async (dispatch) => {
  dispatch({
    type: SET_DOWNLOAD_PROGRESS,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setUploadProgress = (data) => async (dispatch) => {
  dispatch({
    type: SET_UPLOAD_PROGRESS,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setMobileView = (data) => async (dispatch) => {
  dispatch({
    type: SET_MOBILE_VIEW,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setGimConnection = (data) => async (dispatch) => {
  dispatch({
    type: SET_GIM_CONNECTION,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const changeLanuage = (data) => async (dispatch) => {
  externalApi.defaults.headers.common.Language = `${data}`;
  dispatch({
    type: CHANGE_LANGUAGE,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const updateStoreProjects = (projects) => (dispatch) => {
  dispatch({
    type: PROJECT_LIST,
    payload: projects,
  });
};

/**
 *
 * @returns
 */
export const updateStoreGimProjects = (projects) => (dispatch) => {
  dispatch({
    type: GIM_PROJECTS,
    payload: projects,
  });
};

/**
 *
 * @returns
 */
export const updateStoreFileList = (files) => (dispatch) => {
  dispatch({
    type: FILE_LIST,
    payload: files,
  });
};

/**
 *
 * @returns
 */
export const updateStoreFileURL = (url) => (dispatch) => {
  dispatch({
    type: FILE_URL,
    payload: url,
  });
};

/**
 *
 * @returns
 */
export const updateStoreFileTypes = (fileTypes) => (dispatch) => {
  dispatch({
    type: FILE_TYPES,
    payload: fileTypes,
  });
};

/**
 *
 * @returns
 */
export const updateAllowedExtensionList =
  (allowedExtensionLists) => (dispatch) => {
    dispatch({
      type: ALLOWED_EXTENSIONS,
      payload: allowedExtensionLists,
    });
  };

/**
 *
 * @returns
 */
export const getProjects = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/SearchProjects',
    data,
  });

  if (response.data?.Result.projects) {
    const updatedProjects = response.data?.Result.projects.map((project) => {
      const tempProjects = storeInstance.getState().user.gimProjects;
      // if (tempProjects?.projectList && tempProjects?.projectList?.length > 0) {
      const gimProject = storeInstance
        .getState()
        .user.gimProjects?.projectList?.filter(
          (gp) => gp.projectId === project.projectId
        );

      if (gimProject && gimProject?.length) {
        project.filePath = gimProject[0].filePath;

        project.uploadGimUnit = gimProject[0]?.uploadGimUnit ?? '';
        project.downloadGimUnit = gimProject[0]?.downloadGimUnit ?? '';
        project.uploadAutoSync = gimProject[0]?.uploadAutoSync;
        project.downloadAutoSync = gimProject[0]?.downloadAutoSync;

        if (project?.subProjects?.length > 0) {
          project.subProjects.map((proj) => {
            const gimSubProject = storeInstance
              .getState()
              .user.gimProjects?.projectList.filter(
                (gp) => gp.projectId === proj.projectId
              );
            if (gimSubProject && gimSubProject.length) {
              proj.filePath = gimSubProject[0].filePath;

              proj.uploadGimUnit = gimSubProject[0]?.uploadGimUnit ?? '';
              proj.downloadGimUnit = gimSubProject[0]?.downloadGimUnit ?? '';
              proj.uploadAutoSync = gimSubProject[0]?.uploadAutoSync;
              proj.downloadAutoSync = gimSubProject[0]?.downloadAutoSync;
            }
          });
        }
      } else {
        project.filePath = '';
      }

      if (project?.customBuilt && project?.subProjects?.length > 0) {
        project.subProjects.map((proj) => {
          if (proj?.customBuilt && proj?.subProjectId === 0) {
            proj.parentProjectId = proj?.projectId;
            proj.projectId = `${proj?.projectId}_${proj?.subProjectId}`;
          }
        });
      }
      // }

      if (data?.subProjectId === 0 && project?.customBuilt) {
        project.subProjectId = 0;
        project.parentProjectId = project?.projectId;
        project.projectId = `${project?.projectId}_${data?.subProjectId}`;
      }

      project.uuid = '';
      project.name = project.projectName;
      project.type = 'project';
      return project;
    });
    dispatch(updateStoreProjects(updatedProjects));
    return updatedProjects;
  }
  return response.data?.Result;
};

/**
 *
 * @returns
 */
export const getPlots = (data) => async (dispatch) => {
  try {
    const response = await externalApi({
      method: 'GET',
      url: `Project/SearchPlotIds?${data}`,
    });
    return response?.data;
  } catch (e) {
    // if (response.data.projects) {
  }
};

/**
 *
 * @returns
 */
export const checkFileOnServer = (guid, type) => async (dispatch) => {
  let fileType = type ? type?.toLowerCase() : 'json';
  // dispatch({ type: FETCH_FILE_REQUEST })
  const response = await externalApi({
    method: 'GET',
    url: `TestUploadFiles/${guid}.${fileType}`,
  })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e?.response ?? e;
    });
  return response;
};

/**
 *
 * @returns
 */
export const userSignOut = (data) => async (dispatch, getState) => {
  const accessToken = getState()?.auth?.authToken || '';
  try {
    await logoutBrowserSession(accessToken);
  } catch {
    // Local logout still proceeds if the remote revoke request fails.
  }
  const avatar = getState()?.user?.avatar;
  if (typeof avatar === 'string' && avatar.length > 0) {
    URL.revokeObjectURL(avatar);
  }
  externalApi.defaults.headers.common.Authorization = null;
  dispatch({
    type: LOG_OUT,
  });
  publishAuthEvent({
    type: 'logged-out',
    authSessionEpoch: getState()?.auth?.authSessionEpoch ?? 0,
  });
};

// /**
//  *
//  * @returns
//  */
// export const getAllProjects = (data) => async (dispatch) => {
//   const response = await externalApi({
//     method: 'GET',
//     url: `Project/GetAllProjects${data}`,
//   });
//   return response.data;
// };

/**
 *
 * @returns
 */
export const updateCustomStyle = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/UpdateCustomStyle',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getCustomStyleByProjectId = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `Project/GetCustomStyleByProjectId?${data}`,
  });
  if (!!response?.data?.Result && response?.data?.Result?.trim()?.length > 0) {
    dispatch({
      type: SET_CUSTOMIZE_DATA,
      payload: JSON.parse(response?.data?.Result),
    });
  } else {
    dispatch({
      type: SET_CUSTOMIZE_DATA,
      payload: null,
    });
  }
  return response.data;
};

/**
 *
 * @returns
 */
export const updateProjectById = (data) => async (dispatch) => {
  const response = await externalApi.post('Project/UpdateProject', data);
  return assertProjectApiSuccess(response.data);
};

/**
 *
 * @returns
 */
export const getAllUsers = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: '/user/GetAllUsers',
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const createProject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/InsertProject',
    data,
  });
  return assertProjectApiSuccess(response.data);
};

/**
 *
 * @returns
 */
export const deleteProjectById = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/DeleteProject',
    data,
  });
  return assertProjectApiSuccess(response.data);
};

/**
 *
 * @returns
 */
export const addMemberToProject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/AddProjectMember',
    data,
  });
  return assertProjectApiSuccess(response.data);
};

/**
 *
 * @returns
 */
export const updateMemberToProject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/UpdateProjectMember',
    // url: 'Project/UpdateMembers',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const removeMemberFromProject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'Project/DeleteRevertProjectMember',
    data,
  });
  return assertProjectApiSuccess(response.data);
};

/**
 *
 * @returns
 */
// export const getAllProjectMembers = (params) => async (dispatch) => {
//   const response = await externalApi({
//     method: 'GET',
//     url: 'Project/GetProjectMembers',
//     params,
//   });

//   return response.data?.Result;
// };

export const getAllProjectMembers = (projectId) => async (dispatch) => {
  if (!projectId) throw new Error('ProjectId is required');
  const response = await externalApi.get('Project/GetProjectMembers', {
    params: { projectId },
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const CheckDomainByProjectId = (data) => async (dispatch) => {
  try {
    const response = await externalApi({
      method: 'POST',
      url: 'Project/CheckDomainByProjectId',
      data,
    });

    if (response.data.ProjectDetails) {
      let projects = [response?.data?.ProjectDetails];
      const updatedProjects = projects.map((project) => {
        const tempProjects = storeInstance.getState().user.gimProjects;
        //@ts-ignore
        if (tempProjects && tempProjects?.length > 0) {
          const gimProject = storeInstance
            .getState()
            //@ts-ignore
            .user.gimProjects.filter(
              (gp) => gp.projectId === project.ProjectId
            );
          if (gimProject && gimProject.length) {
            project.filePath = gimProject[0].filePath;
          } else {
            project.filePath = '';
          }
        }
        project.projectMemberAccessRights =
          project?.projectMembers?.length > 0
            ? (project?.projectMembers?.[0]?.AccessRights ?? '')
            : '';
        project.uuid = '';
        project.name = project.projectName;
        project.type = 'project';
        project.isProjectMember = true;
        return project;
      });
      dispatch(updateStoreProjects(updatedProjects));
    }
    return response.data;
  } catch (e) {
    console.log(e, e?.response);
  }
};

/**
 *
 * @returns
 */
export const getIndustryList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: '/Project/GetIndustryList',
  });
  return response;
};

/**
 *
 * @returns
 */
export const getBuildingList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: '/Project/GetBuildingTypes',
  });
  return response;
};

/**
 *
 * @returns
 */
export const checkEmailVerifyStatus = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/CheckVericationInvoiceAddress',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const verifyEmail = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/VerifyInvoiceAddress',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getInvoiceList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetInvoicePaymentList${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const updatePaymentStatus = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/UpdatePaymentStatus',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const lockUnlockProject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/LockUnlockProject',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const activeInactiveProject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/ActiveInactiveProject',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const sendEmailInvoice = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/SendInvoicePerMonth',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getProjectOverviewList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetProjectOverviewList${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const updateProjectOverview = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/UpdateProjectOverview',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const deleteRetrieveProjectOverview = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/DeleteRevertProjectOverview',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getFileTypeList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: '/Project/GetFileTypeList',
  });
  return response;
};

/**
 *
 * @returns
 */
export const updateUserSettings = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: `/object/UpdateUserSettings/${data?.update}`,
    data: data?.payload,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getUserSettings = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/object/GetUserSettings?userId=${data}`,
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getFileTypesList = (params) => async (dispatch) => {
  // const response = await externalApi({
  //   method: 'POST',
  //   url: '/Project/GetFileTypesByProjectId',
  //   data,
  // })
  const response = await externalApi({
    method: 'GET',
    url: '/object/GetFileTypesByGuid',
    params,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getAllInstances = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetInstanceListByRegion?${data}`,
    // url: `/Project/GetAllInstances?${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getObjectDefinition = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/GetDefinitionData',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getLocationList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetObjectLocationList?${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getLocationById = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetObjectLocationById?${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const addObjectLocation = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/AddObjectLocation',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const updateObjectLocation = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/UpdateObjectLocation',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const deleteObjectLocation = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/DeleteObjectLocation',
    data,
  });
  return response.data;
};

// Test cases
/**
 *
 * @returns
 */
export const setInitialtProjectList = (projects) => (dispatch) => {
  dispatch({
    type: INIT_PROJECT_LIST,
    payload: projects,
  });
};

/**
 *
 * @returns
 */
export const setSelectedProjectData = (projects) => (dispatch) => {
  dispatch({
    type: C_INPUT_LIST,
    payload: projects?.[0],
  });
};

/**
 *
 * @returns
 */
export const industryData = (industry) => (dispatch) => {
  dispatch({
    type: INDUSTRY_DATA,
    payload: industry,
  });
};

/**
 *
 * @returns
 */
export const userInfoDetails = (userInfo) => (dispatch) => {
  dispatch({
    type: USER_INFO,
    payload: userInfo,
  });
};
/**
 *
 * @returns
 */
export const invoiceListData = (invoice) => (dispatch) => {
  dispatch({
    type: INVOICE_LIST,
    payload: invoice,
  });
};

/**
 *
 * @returns
 */
export const getWpPage = (data) => async (dispatch) => {
  const response = await wpApi({
    method: 'GET',
    url: `${data}`,
  });
  return response;
};
